import { render, staticRenderFns } from "./ProductosEmpresaCategorias.vue?vue&type=template&id=20645a5e&scoped=true&"
import script from "./ProductosEmpresaCategorias.vue?vue&type=script&lang=js&"
export * from "./ProductosEmpresaCategorias.vue?vue&type=script&lang=js&"
import style0 from "./ProductosEmpresaCategorias.vue?vue&type=style&index=0&id=20645a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20645a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VRow})
